import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import GetParsedDate from "../shared/GetParsedDate";
import MyJustDate from "../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

const MoamadExtentionDateRep = ({ proposalStatus }) => {
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [moamadsExtentionDatesRep, updateMoamadsExtentionDatesRep] = useState(
    [],
  );
  const now = MyJustDate(new Date());
  const axiosPrivate = useAxiosPrivate("application/json");
  const history = useNavigate();

  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    let isMounted = true;
    const controller = new AbortController();

    const getMoamadRep = async () => {
      try {
        const response = await axiosPrivate.get(
          `${baseURL}MoamadeemExtentionDate`,
          { signal: controller.signal },
        );

        if (isMounted) {
          updateMoamadsExtentionDatesRep(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            "The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert("Anything else1");
        }
      }
    };
    //getMoamadRep();
    return () => {
      document.body.classList.remove("accountBodyColor");
      isMounted = false;
      controller.abort();
    };
  }, []);

  const runRep = () => {
    document.body.classList.add("accountBodyColor");
    let isMounted = true;
    const controller = new AbortController();
    const getMoamadRep = async () => {
      try {
        const response = await axiosPrivate.get(
          // `${baseURL}MoamadeemExtentionDate`,
          `${baseURL}MoamadeemExtentionDate/?fromdate=${fromDate}&todate=${toDate}`,
          { signal: controller.signal },
        );

        if (isMounted) {
          updateMoamadsExtentionDatesRep(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            "The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert("Anything else1");
        }
      }
    };
    getMoamadRep();
    return () => {
      document.body.classList.remove("accountBodyColor");
      isMounted = false;
      controller.abort();
    };
  };
  /*
  const handleTdClick = (
    moamadId,
    userId,
    mekhrazTitle,
    isDisabledDocument
  ) => {
    const url = `/moamadadmin/${moamadId}/${userId}/${encodeURIComponent(
      mekhrazTitle
    )}/${isDisabledDocument}`;
    history(url);
  };*/

  const handleTdClick = (
    moamadId,
    userId,
    mekhrazTitle,
    isDisabledDocument,
  ) => {
    history("/moamadadmin", {
      state: {
        moamad_id: moamadId,
        user_id: userId,
        mekhraz_title: mekhrazTitle,
        is_disabled_doc: isDisabledDocument,
      },
    });
  };
  const handleClickButton = () => {
    if (fromDate > toDate) {
      alert("תאריך מיום גדול מתאריך עד!!!!!");
    } else {
      runRep();
    }
  };

  return (
    <div>
      <h2 style={{ textAlign: "center", color: "white" }}>
        מועמדים שהוארכה להם תקופת הגשת מסמכים
      </h2>
      <form>
        <div style={{ textAlign: "center" }}>
          <Row>
            <Col>
              <label
                style={{
                  color: "black",
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                מיום
              </label>
              <input
                type="date"
                name="fromDate"
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
                className="form-control"
                id="fromDate"
              />
            </Col>
            <Col>
              <label
                style={{
                  color: "black",
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                עד יום
              </label>
              <input
                type="date"
                name="toDate"
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
                className="form-control"
                id="toDate"
              />
            </Col>
          </Row>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClickButton}
          >
            חפש
          </button>
        </div>
      </form>
      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          <h4 className="text-color">
            {moamadsExtentionDatesRep?.length} הגשות
          </h4>
        </center>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table className="centered-table">
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מזהה
                </th>

                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  שם מלא
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מס' מכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאור המכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך הארכה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך הגשה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תנאי הסף
                </th>
              </tr>
            </thead>
            <tbody>
              {moamadsExtentionDatesRep
                ?.sort((a, b) => b.id - a.id)
                .map((item, index) => {
                  const isDisabled =
                    proposalStatus === "חסויה" &&
                    MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;
                  const isDisabledDocument =
                    proposalStatus === "מסמכים חסויים" &&
                    MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;

                  return (
                    <tr style={{ borderBottom: "1px solid #ddd" }} key={index}>
                      <td
                        isDisabled={isDisabled}
                        className="changetextsize-td"
                        style={{
                          textAlign: "center",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          color: isDisabled ? "gray" : "blue",
                          textDecoration: isDisabled ? "none" : "underline",
                        }}
                        onClick={() => {
                          if (!isDisabled) {
                            handleTdClick(
                              item.id,
                              item.user,
                              item.mekhraz__title,
                              isDisabledDocument,
                            );
                          }
                        }}
                      >
                        {item.id}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {`${item.f_name} ${
                          item.father_name ? item.father_name + " " : ""
                        } ${item.l_name}`}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.mekhraz__mkh_num}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.mekhraz__title}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        <GetParsedDate
                          strDate={item.extention_date}
                          withTime={false}
                        />
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.signature_date ? (
                          <GetParsedDate
                            strDate={item.signature_date}
                            withTime={false}
                          />
                        ) : (
                          "לא הוגשה"
                        )}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.saf ? "כן" : "לא"}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {moamadsExtentionDatesRep?.results?.length === 0 && (
            <p
              style={{
                color: "blue",
                fontWeight: "bold",
                fontSize: "20px",
                textDecoration: "underline",
              }}
            >
              לא קיימות הגשות מתאריך זה
            </p>
          )}
        </div>
      </div>
      <br />
    </div>
  );
};

export default MoamadExtentionDateRep;
